import { Button, styled } from "@mui/material";

/**
 * SoftBlueButton component is a styled Material-UI Button with custom styles.
 * @param {object} props - Component props.
 * @param {string} [props.width="60%"] - Button width.
 * @param {string} [props.height="66px"] - Button height.
 * @returns {JSX.Element} Styled Material-UI Button component.
 */
export const SoftBlueButton = styled(Button)(({ width, height }) => ({
  justifyContent: "center",
  alignItems: "center",
  padding: "15px 25px",
  gap: "10px",
  width: width || "60%",
  fontFamily: "Lexend",
  textTransform: "none",
  fontWeight: 500,
  height: height ? height : "66px",
  margin: "2%",
  fontSize: 19,
  border: "5px solid #6784F6",
  backgroundColor: "#90A4F3",
  color: "#fff",
  borderRadius: "32px",
  boxShadow: "10px 10px 37px 0px #00000040",
  "&:hover": {
    border: "5px solid #6784F6",
    backgroundColor: "#90A4F3",
    color: "#fff",
    fontFamily: "Lexend",
    textTransform: "none",
    fontWeight: 500,
  },
}));
